import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 4v16a1 1 0 0 0 1.524 .852l13 -8a1 1 0 0 0 0 -1.704l-13 -8a1 1 0 0 0 -1.524 .852z","key":"svg-0"}]]

/**
 * IconPlayerPlayFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItcGxheWVyLXBsYXkiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgNHYxNmExIDEgMCAwIDAgMS41MjQgLjg1MmwxMyAtOGExIDEgMCAwIDAgMCAtMS43MDRsLTEzIC04YTEgMSAwIDAgMCAtMS41MjQgLjg1MnoiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/player-play-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPlayerPlayFilled = createReactComponent('filled', 'player-play-filled', 'PlayerPlayFilled', __iconNode);

export default IconPlayerPlayFilled;